/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const SET_POLICY_ENTITIES_FORM_DATA = 'SET_POLICY_ENTITIES_FORM_DATA';
export const SET_ENTITIES_LIST = 'SET_ENTITIES_LIST';
export const SET_ENTITIES_ATTRIBUTES_LIST = 'SET_ENTITIES_ATTRIBUTES_LIST';
export const SET_ENTITIES_REMOTE_DATA_URL_OBJECT = 'SET_ENTITIES_REMOTE_DATA_URL_OBJECT';
export const SET_POLICY_ENTITIES_FORM_ERROR = 'SET_POLICY_ENTITIES_FORM_ERROR';
export const UPDATE_POLICY_ENTITIES_FORM_ERROR = 'UPDATE_POLICY_ENTITIES_FORM_ERROR';
export const RESET_POLICY_ENTITIES_FORM = 'RESET_POLICY_ENTITIES_FORM';
export const ADD_ATTRIBUTE = 'ADD_ATTRIBUTE';
export const SET_ATTRIBUTE_FORM_DATA = 'SET_ATTRIBUTE_FORM_DATA';
export const SET_ATTRIBUTE_ERROR_FORM_DATA = 'SET_ATTRIBUTE_ERROR_FORM_DATA';
export const SET_RESOURCE_NS = 'SET_RESOURCE_NS';
export const SET_RESOURCES = 'SET_RESOURCES';
export const SET_DP_MODEL = 'SET_DP_MODEL';
export const ADD_COLUMN_ATTRIBUTE = 'ADD_COLUMN_ATTRIBUTE';
export const SET_COLUMN_ATTRIBUTE_FORM_DATA = 'SET_COLUMN_ATTRIBUTE_FORM_DATA';
export const SET_COLUMN_ATTRIBUTE_ERROR_FORM_DATA = 'SET_COLUMN_ATTRIBUTE_ERROR_FORM_DATA';
export const RESET_ENTITY_POLICY_ATTRIBUTES = "RESET_ENTITY_POLICY_ATTRIBUTES";
export const SET_RESOURCE_PAGINATION = "SET_RESOURCE_PAGINATION";
export const SET_REMOTE_URL_RESPONSE_DATA = "SET_REMOTE_URL_RESPONSE_DATA";
export const RESET_REMOTE_URL_RESPONSE_DATA = "RESET_REMOTE_URL_RESPONSE_DATA";